document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-newsletter-modal]');
  const open = document.querySelector('[data-open-newsletter]');
  const close = document.querySelectorAll('[data-close-newsletter]');
  if (!modal || !open) return;
  const show = () => { modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); };
  const hide = () => { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); };
  open.addEventListener('click', show);
  close.forEach(el => el.addEventListener('click', hide));
  modal.addEventListener('click', e => { if (e.target === modal) hide(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') hide(); });
});
